import styled from 'styled-components';

export const Button = styled.button`
  border-radius: 8px;
  transition: 0.3s;
  box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.1);
  border: none;
  &:hover {
    opacity: 0.8;
  }
  @media only screen and (max-width: 768px) {
    margin-right: 10px;
  }
`;

export const Box = styled.div`
  display: flex;
  flex-direction: row;
  height: 70px;
  width: 260px;
  border-radius: 8px;
`;

export const GreenBox = styled.div`
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  background: #0db14b;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 70px;
  color: #fff;
`;

export const WhiteBox = styled.div`
  width: 240px;
  transition: 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  color: #333333;
  font-family: 'Roboto';
  font-weight: 500;
`;
